import React, {useEffect, useState} from "react";
import Box from "@material-ui/core/Box";
import SummaryCard from "./SummaryCard";
import {useOrganization} from "../../../hooks/useOrganization";
import service from "../../../service/service";
import {jsonParser} from "../../../helper/generalFunctions";
import RecommendationCheckDetails from "./RecommendationCheckDetails";
import {Typography} from "@material-ui/core";
import {ProgressCircleCustomSize} from "../../ProgressCircle/ProgressCircle";
import {AlertWu} from "../../AlertWu/AlertWu";
import WuTagAndRegionFilter from "../../General/WuTagAndRegionFilter";
import {HelpOutlineOutlined} from "@material-ui/icons";
import WuToolTip from "../../General/WuToolTip";
import WuFloatingDownloadButton from "../../General/WuFloatingDownloadButton";

export default function TrustedAdvisorRecommendations() {
    const {organization} = useOrganization();
    const [loading, setLoading] = useState(false);
    const [ready, setReady] = useState(false);
    const [error, setError] = useState({error: false, message: undefined});
    const [checkData, setCheckData] = useState([]);
    const [filter, setFilter] = useState({});

    const fetchData = async () => {
        try {
            setReady(false);
            setLoading(true);
            setError({error: false, message: undefined})
            const params = {master_account_id: organization, filter: filter}
            const {data: {data}} = await service.recommendations().getTrustedAdvisorChecks(params);
            setCheckData(data);
            setReady(true)
        } catch (e) {
            const errorBody = jsonParser(e.request.response);
            setError({error: true, message: errorBody ? errorBody.error : e.message})
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (organization !== 'no org') {
            fetchData()
        }
    }, [organization, filter])


    return (
        <Box display={'flex'} className={'gap'}>
            <WuFloatingDownloadButton serviceFn={service.recommendations().getTrustedAdvisorReportDownload}/>
            <Box width={"100%"}>
                <Box mt={0} mb={2} className={'gap'} display={'flex'} alignItems={'center'}>
                    <WuTagAndRegionFilter disabled={false} regionEnable={false} onClick={(e) => setFilter(e)}/>
                    <WuToolTip
                        title={'Tag filter supported for Low Utilization EC2, Amazon RDS Idle DB Instance, Idle Load Balancer'}>
                        <HelpOutlineOutlined style={{color: 'var(--secondary-highlight)'}}/>
                    </WuToolTip>
                </Box>

                {
                    ready &&
                    checkData.map(({CheckId, CheckName, EstimatedMonthlySaving}) => <RecommendationCheckDetails
                        key={`${organization}${CheckId}`}
                        filter={filter}
                        EstimatedMonthlySaving={EstimatedMonthlySaving}
                        masterAccountId={organization}
                        checkId={CheckId}
                        checkName={CheckName}/>)
                }
                {
                    loading &&
                    <Loading message={organization}/>
                }
                <AlertWu alertOpen={{state: error.error}} title={"Error"} severity={'error'}
                         message={error.message}/>
            </Box>
            <Box width={300}>
                <SummaryCard filter={filter}/>
            </Box>
        </Box>
    )
}

function Loading({message}) {
    return (
        <Box display={'flex'} alignItems={'center'} gridGap={8}>
            <ProgressCircleCustomSize size={16}/>
            <Typography>Loading recommendations for {message}...</Typography>
        </Box>
    )
}

